<template>
    <div>
        <content-loader v-if="$apollo.loading" title="Network details"/>
        <div v-else>
            <div class="banner">
                <network-map-card :network="network"></network-map-card>
            </div>

            <div class="top-block mb-3 mb-md-5 mb-lg-4">
                <div class="container">
                    <div class="row no-gutters">
                        <div class="col-lg-3">
                            <div class="network-image" v-imagekit.background="{ image: network.picture, transform: 'w-300,h-240,fo-auto'}"></div>
                        </div>
                        <div class="col-lg-9">
                            <div class="basic-info">
                                <div class="row">
                                    <div class="col-md-7">
                                        <h5 class="card-title">About</h5>
                                        <p class="description">{{ network.description }}</p>
                                    </div>
                                    <div class="col-md-5">
                                        <member-info-card v-if="network.manager" card-title="Community Manager" :member="network.manager"></member-info-card>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container mb-5">
                <div class="row">
                    <div class="col-lg-3">&nbsp;</div>
                    <div class="col-lg-9">
                        <div class="block" v-if="network.people.length">
                            <member-list-card card-title="Latest Members" :members="displayMembers" limit="3"></member-list-card>
                        </div>
                        <!-- JOBS ? -->
                        <div class="block" v-if="network.insights.length">
                            <network-insights-card :insights="network.insights"></network-insights-card>
                        </div>
                        <div class="block" v-if="network.events.length">
                            <network-events-card :events="displayEvents"></network-events-card>
                        </div>
                        <div class="block" v-if="network.sponsors.length">
                            <network-sponsors-card :sponsors="network.sponsors"></network-sponsors-card>
                        </div>
                        <div class="block" v-if="network.perks.length">
                            <network-perks-card :perks="network.perks"></network-perks-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { GetNetworkDetail } from "@/gql/GetNetworkDetail.gql";
    import PageHeader from '@/components/global/PageHeader';
    import ContentLoader from '@/components/global/ContentLoader';
    import NetworkMapCard from "@/components/networks/NetworkMapCard";
    import MemberInfoCard from "@/components/global/MemberInfoCard";
    import MemberListCard from "@/components/global/MemberListCard";
    import NetworkEventsCard from "@/components/networks/NetworkEventsCard";
    import NetworkInsightsCard from "@/components/networks/NetworkInsightsCard";
    import NetworkSponsorsCard from "@/components/networks/NetworkSponsorsCard";
    import NetworkPerksCard from "@/components/networks/NetworkPerksCard";

    export default {
        name: 'network-detail',

        components: {
            PageHeader,
            ContentLoader,
            NetworkMapCard,
            MemberInfoCard,
            MemberListCard,
            NetworkEventsCard,
            NetworkSponsorsCard,
            NetworkInsightsCard,
            NetworkPerksCard,
        },

        apollo: {
            network: {
                query: GetNetworkDetail,
                variables() {
                    return {
                        id: this.$route.params.id
                    }
                }
            }
        },

        computed: {
            displayEvents() {
                return this.network.events && this.network.events.map(event => {
                    return event.event;
                });
            },

            displayMembers() {
                return this.network.people && this.network.people.map(person => {
                    return person.person;
                });
            }
        },
    }
</script>

<style lang="scss" scoped>
.top-block {
    background-color: #ffffff;

    @include media-breakpoint-up(lg) {
        background-color: transparent;
        margin-top: -80px;
    }

    .row {
        @include media-breakpoint-up(lg) {
            margin-right: -24px;
        }
    }
}

.network-image {
    display: none;
    @include media-breakpoint-up(lg) {
        display: block;
        height: 235px;
        background-color: $grey;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: top center;
    }
}
.basic-info {
    background-color: #ffffff;
    padding: 15px;

    @include media-breakpoint-up(lg) {
        padding: 25px;
    }

    p.description {
        font-size: 15px;
        color: #505B64;
    }
}

.block {
    position: relative;

    &:last-of-type {
        &:after {
            content: none;
        }
    }

    &:after {
        content: '';
        width: 100%;
        height: 1px;
        background-color: #E8E8E8;
        position: absolute;
        bottom: -13px;
        left: 0;
    }
}
</style>
